import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { OverviewComponent } from '@/app/components/projects/project-stages/project-brief/add-project-module/brief-sections/overview/overview.component';

@Component({
  selector: 'app-tooltips',
  standalone: true,
  imports: [OverviewComponent],
  templateUrl: './tooltips.component.html',
  styleUrl: './tooltips.component.css',
})
export class TooltipsComponent {
  @Input() tooltipText = '';
  constructor(private router: Router) {}

  // Function called when <p> is clicked
  callAnotherComponent() {
    // Example action: Navigate to another component
    this.router.navigate(['/another-component']);

    // You can perform other actions here, such as calling a service
    console.log('Function triggered!');
  }
}
